import { ErrorHandler, Injectable } from "@angular/core";
import { ApplicationInsightsLogger } from "./applications-insights-logger";

@Injectable()
export class ErrorsHandlerService extends ErrorHandler {

private readonly loggingService : ApplicationInsightsLogger ; 

    constructor(private applicationInsightLogger: ApplicationInsightsLogger) {
        super();
        this.loggingService = applicationInsightLogger ;
    }

    handleError(error: Error) {
        console.error(error) ; 
        this.loggingService.logException(error); // Manually log exception
    }
}